const Footer = () => {

  if (window.location.hash === '#/login') return null;

  return (
    <footer class="vh-footer-wrap" id="footer">
			<div class="vw-inner">
				<a href="" class="footer-logo">
					<img src="/static/img/logo/logo-footer.png" />
				</a>
				<ul class="footer-social">
					<li><a href="" title="블로그"><img src="/static/img/assets/footer_social_01.png" alt="블로그" /></a></li>
					<li><a href="" title="유튜브"><img src="/static/img/assets/footer_social_02.png" alt="유튜브" /></a></li>
					<li><a href="" title="인스타그램"><img src="/static/img/assets/footer_social_03.png" alt="인스타그램" /></a></li>
				</ul>
				<address class="footer-info">
					<div class="footer-info-tit">	
						<strong>에이치코</strong>
					</div>
					<div class="footer-info-row">	
						<span>사업자 번호: 280-26-00396</span>
						<span>통신판매업신고: 2023-경기하남-0304</span>
						<span>대표:정동환</span>
					</div>

					<div class="footer-info-row">
						<div>
							<i class="icon icon-tel"></i>
							<span>TEL</span>
							<a href="tel:1566-3046">1566-3046</a>
						</div>

						<div>
							<i class="icon icon-mail"></i>
							<span>Mail</span>
							<a href="mailto:jdhwan227@naver.com">jdhwan227@naver.com</a>
						</div>

						<div>
							<i class="icon icon-mark"></i>
							<span>Loaction</span>
							<span>경기도 하남시 조정대로 45, F318</span>
						</div>						
					</div>
				</address>
				<ul class="footer-gnb">
					<li><a href="">개인정보 처리방침</a></li>
					<li><a href="">면책공고</a></li>
					<li><a href="">이메일 무단 수집 거부</a></li>
				</ul>
				<p class="copyright">© 2025. All rights reserved.</p>
			</div>
		</footer>
  );
}

export default Footer;